import { DateTime } from 'luxon';
import React, { Fragment, useContext } from 'react';
import { Button, Link, LocaleContext } from 'shared';

import { BackButton, DeleteWrapper, PageHeader, PageHeaderWrapper } from './ApplicationHeader.styles';
import { ApplicationHeaderProps } from './ApplicationHeader.types';

export const ApplicationHeader = ({ name, backUrl, env, createdAt, onDelete }: ApplicationHeaderProps) => {
  const localeContext = useContext(LocaleContext);

  const handleDelete = onDelete ? () => onDelete() : undefined;

  return (
    <PageHeaderWrapper>
      <PageHeader
        meta={
          <Fragment>
            <span>
              {' '}
              {localeContext.formatMessage({ id: 'GENERAL.CREATED' })}:{' '}
              {DateTime.fromISO(createdAt).toLocaleString(DateTime.DATE_SHORT)}
            </span>
          </Fragment>
        }
      >
        <span className="page-header__title">
          <Link url={backUrl}>
            <BackButton className="page-header__back-button" />
          </Link>
          <span className="page-header__title-text">{name}</span>
        </span>
        <Button type="select" className="selected page-header__environment">
          {env}
        </Button>
      </PageHeader>
      {handleDelete && (
        <DeleteWrapper>
          <Button
            type={'portal-lite'}
            icon={['1.5rem', 'removeIcon']}
            iconAfterText={true}
            onClick={handleDelete}
            className="button--application-delete"
          >
            {localeContext.formatMessage({ id: 'APPLICATION-HEADER.DELETE-APPLICATION' })}
          </Button>
        </DeleteWrapper>
      )}
    </PageHeaderWrapper>
  );
};
